import React from 'react';
import { Typography } from '@mui/material';
import posterImage from '../assets/images/admin_portal_image.png';
import posterText from '../assets/images/admin_portal_text.png';
import PropTypes from 'prop-types';

const TaskTemplateSelector = ({ index, selectedTemplate, onChange }) => {

  const templates = [
    { label: 'image', value: 'image', image: posterImage },
    { label: 'text', value: 'text', image: posterText },
  ];
  const GetBorderStyle = ( isDisabled ) => {
      if(isDisabled){
        return '1px solid #6e6963';
      }
      return '1px solid';
    }
    GetBorderStyle.propTypes =  {
      isDisabled: PropTypes.any
    }

    const styles = {
      itemBlock: {
        margin: '20px 0',
      },
      itemTitle: {
        fontWeight: 'bold',
        marginBottom: '10px',
      },
      templateOptions: {
        display: 'flex',
        gap: '20px',
        marginTop: '10px',
      },
      templateOption:{
        display: 'flex',
        cursor: 'pointer',
        pointerEvents: 'auto'
      },
      templateBox: (isSelected, isDisabled) => ({
        width: '130px',
        height: '130px',
        border: isSelected ? '3px solid' : GetBorderStyle(isDisabled),
        filter: isDisabled ? 'grayscale(1) brightness(2)' : 'none'
      }),
      radio: {
        marginBottom: '8px',
        width: '18px',
        height: '18px',
        accentColor: 'black'
      },
      label: {
        fontSize: '16px',
        fontWeight: '500'
      }
    };

    return (
      <div style={styles.itemBlock}>
        <Typography sx={{ fontSize: '16px', fontWeight: 'bold', marginBottom: '4px' }}>Select task template</Typography>
        <div style={styles.templateOptions}>
          {templates.map((template) => {
            const isSelected = selectedTemplate === template.value;
            const isDisabled = selectedTemplate && !isSelected;
            return (
              <label key={template.value} style={styles.templateOption}>
                <input
                  type="radio"
                  name={`template-${index}`}
                  value={template.value}
                  checked={selectedTemplate === template.value}
                  onChange={() => onChange(index, template.value)}
                  style={styles.radio}
                />
                <div>
                  <img src={template.image} style={styles.templateBox(isSelected, isDisabled)} alt={template.label}></img>
                  <div style={styles.label}>{template.label}</div>
                </div>
              </label>
            )
          })}
        </div>
      </div>
    );
  };
  TaskTemplateSelector.propTypes =  {
    index: PropTypes.number.isRequired,
    selectedTemplate: PropTypes.any,
    onChange: PropTypes.any
  }
  export default TaskTemplateSelector;